import {Component, ElementRef, Input, OnInit} from '@angular/core';
import {TripEntry} from "../trip-list/trip-list.component";
import {Entries} from "../animal-rarities/animal-rarities-classes";
import {PhotoGallerySettings} from "../../../widgets/fancy-photo-gallery/fancy-photo-gallery/fancy-photo-classes";
import {GoogleMapStyles, Park} from "../../../../google-maps-points";
import {LazyLoaderService} from "../../../../core/services/lazy-loader/lazy-loader.service";
import {HotelService} from "../../hotel.service";
import {Router} from "@angular/router";
import {NationalParkService} from "../../national-park.service";

@Component({
  selector: 'app-national-park',
  templateUrl: './national-park.component.html',
  styleUrls: ['./national-park.component.css']
})
export class NationalParkComponent implements OnInit {

  @Input()
  tripEntries: TripEntry[];

  @Input()
  mapLat: number;

  @Input()
  mapLng: number;

  @Input()
  animals: boolean;

  @Input()
  animalEntries: Entries;

  @Input()
  galleries: PhotoGallerySettings[];

  @Input()
  parkBoundaries: Park[];

  @Input()
  zoom: number;

  @Input()
  parkId: string;

  @Input()
  paragraphs: string[];

  @Input()
  bannerImage: string;

  @Input()
  largeImgHeightAndBackgroundPosition: string[];

  @Input()
  medImgHeightAndBackgroundPosition: string[];

  @Input()
  smallImgHeightAndBackgroundPosition: string[];

  @Input()
  hasBadge: boolean;

  @Input()
  badgeHtml: string;

  @Input()
  paragraphHeaders: string[];

  @Input()
  factsHeader: string;

  @Input()
  factSet: string[];

  @Input()
  tripListParkName: string;

  @Input()
  isOneSpot: boolean;

  @Input()
  mobileTripListHeight: string;

  @Input()
  desktopCircleWidths: string[];

  @Input()
  mobileCircleWidths: string[];

  @Input()
  parkRoute: string;

  googleMapStyles = GoogleMapStyles; // pull from the global export

  constructor( private lazyLoader: LazyLoaderService,
               private elementRef: ElementRef,
               private parkService: NationalParkService,
               private router: Router) { }

  ngOnInit() {
    this.onLoadParkCubes(() => {
      this.parkService.setCurrentParkPage(this.parkRoute, () => {
        this.parkService.removeCurrentPageParkCube();
      });
    });
  }

  onLoadParkCubes(callback) {
    this.lazyLoader.load('app-park-cubes').then(componentEl => {
      componentEl['currentPage'] = this.parkRoute;
      this.elementRef.nativeElement
        .querySelector('#park-cubes-container')
        .appendChild(componentEl);
      callback.apply();
    });
  }

  onMouseOver(infoWindow: any, agmInstance: any, park: Park) {
    if (agmInstance.lastOpen != null) {
      agmInstance.lastOpen.close();
    }
    agmInstance.lastOpen = infoWindow;
    infoWindow.open();
    park.fillColor = park.hoverColor;
  }

  onMouseOut(infoWindow: any, park: Park) {
    infoWindow.close();
    park.fillColor = park.defaultColor;
  }

  isMobile() {
    return document.body.clientWidth < 991.98 && document.body.clientWidth > 767.98;
  }

  mobileZoom() {
    if (document.body.clientWidth < 500) {
      return 7;
    }
    return this.zoom;
  }

  isMobileBr() {
    return document.body.clientWidth < 500;
  }

  tripListNeedsToBeTaller() {
    if(window.location.pathname.indexOf('national-parks/ngorongoro')) {
      return '694px';
    } else {
      return '511.59px';
    }
  }

}
